export const SET_RESEARCH = 'TNS:SET_RESEARCH';
export const RESET_RESEARCH = 'TNS:RESET_RESEARCH';
export const SET_TENANT = 'TNS:SET_TENANT';
export const SET_TENANTS = 'TNS:SET_TENANTS';
export const CLEAR_TENANTS = 'TNS:CLEAR_TENANTS';
